/* eslint-disable import/prefer-default-export */
import { fetch } from 'server/api'
import { forEach } from 'lodash'

export const getStoreLocatorByUid = (storeLocatorUid, params = {}) => {
  let paramsUrl = ''

  const headersToForward = { 'X-Record-Visit': false }

  forEach(params, (value, key) => {
    paramsUrl += `&${key}=${value}`
  })

  return fetch(
    `store_locators/uid/${storeLocatorUid}?${encodeURI(paramsUrl)}`,
    headersToForward,
  )
}
